import { HierarchyArea } from '@plarium/hierarchy-react';
import React from 'react';

import BusinessPartnerDetails from './BusinessPartnerDetails';

export default ({ bpId, disabled = false, ...props }) => (
  <HierarchyArea {...props}>
    {({ area }) =>
      area.data ? (
        <BusinessPartnerDetails
          data={area.data.affiliateContact}
          loading={area.loading}
          bpId={bpId}
          reload={area.reload}
          isEditable={props.isEditable}
          disabled={disabled}
        />
      ) : null
    }
  </HierarchyArea>
);
